"use client";
import Image from "@/components/Image";

const Banner = () => {
  return (
    <section className="w-full relative">
      {/* 背景图片 - 桌面端 */}
      <div className="hidden md:block h-[400px]">
        <Image
          src="/top_banner_11.jpg"
          alt="背景图片"
          fill
          className="object-cover"
        />
      </div>

      {/* 背景图片 - 移动端 */}
      <div className="block md:hidden h-[320px]">
        <Image
          src="/top_banner_768_11.png"
          alt="背景图片"
          fill
          className="object-cover"
        />
      </div>
    </section>
  );
};

export default Banner;
